const STORAGE_KEY = 'coordal.weatherDailyBriefingDismissed';

type DismissRecord = {
  lat: number;
  lng: number;
  date: string;
};

function roundCoord(value: number): number {
  return Math.round(value * 1000) / 1000;
}

function locationKey(lat: number, lng: number): string {
  return `${roundCoord(lat)}:${roundCoord(lng)}`;
}

function todayDateKey(): string {
  return new Date().toISOString().slice(0, 10);
}

function readAll(): DismissRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as DismissRecord[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(entries: DismissRecord[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
}

/** Whether the daily briefing was dismissed for this map point today. */
export function isWeatherDailyBriefingDismissed(lat: number, lng: number): boolean {
  const key = locationKey(lat, lng);
  const today = todayDateKey();
  return readAll().some((entry) => locationKey(entry.lat, entry.lng) === key && entry.date === today);
}

/** Hide the daily briefing for this map point until tomorrow. */
export function markWeatherDailyBriefingDismissed(lat: number, lng: number): void {
  const today = todayDateKey();
  const key = locationKey(lat, lng);
  const next = readAll().filter((entry) => locationKey(entry.lat, entry.lng) !== key || entry.date !== today);
  next.push({ lat: roundCoord(lat), lng: roundCoord(lng), date: today });
  writeAll(next);
}
